import * as React from 'react';

import {
  Row,
  Col,
} from 'antd';

import {
  Props,
} from 'one-ui';

export interface BoxCallingDestinationHeaderProps extends Props {
  note?: string;
  title?: string;
}

export const BoxCallingDestinationHeader = ({
  note,
  title,
  children,
}:BoxCallingDestinationHeaderProps) => (
    <div className="box__top">
      <Row type="flex" gutter={[16, 0]}>
        <Col span={10}>
          <div className="box__title">
            {title}
          </div>
        </Col>
        <Col span={14}>
          <Row type="flex" gutter={[8, 0]} justify={'space-between'}>
            <Col>
              <div className="box__sub-title">
                {note}
              </div>
            </Col>
            <Col>
              <div className="box__actions">
                {children}
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
